import { render, staticRenderFns } from "./print-pack-from.vue?vue&type=template&id=5b71875b&scoped=true&"
import script from "./print-pack-from.vue?vue&type=script&lang=ts&"
export * from "./print-pack-from.vue?vue&type=script&lang=ts&"
import style0 from "./print-pack-from.vue?vue&type=style&index=0&id=5b71875b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b71875b",
  null
  
)

export default component.exports